import { Pipe, PipeTransform } from '@angular/core';
import { MessageStatus } from '../enums/message-status';
import { Message } from '../models/Message';
import { MessageType } from '../enums/message-type';


@Pipe({name: 'canResendConsentMessage'})
export class CanResendConsentMessagePipe implements PipeTransform {
    transform(messages: Message[] | null): boolean {
        // No messages yet, don't show
        if (!messages || messages.length === 0) {
            return false;
        }

        // Recent consent messages sent, don't show
        if (
            messages.filter((message) => {
                return (message.type == MessageType.INITIAL_CONSENT_REQUEST || message.type == MessageType.REOPEN_CONSENT_REQUEST) && 
                    message.status != MessageStatus.failed && 
                    message.createdAt.getTime() > (new Date().getTime() - 60 * 60 * 1000) // less than 60 minutes old;
            }).length > 0
        ) {
            return false;
        }

        // Show if there is a queued message
        if (messages.filter(message => message.status === MessageStatus.queued).length > 0) {
            return true;
        }

        return false;
    }
}
